import { gql } from "@apollo/client";
import { parseTheAdditionInfo } from "../../CommonFunction/parseTheAdditionInfo";

export const PINCODE_QUERY = gql`
  query PincodeQuery($pincode: String) {
    pincode(pincode: $pincode) {
      Pincode
      State
      District
      City
      Towns
    }
  }
`;

export const CheckfieldExistornot = (fields, name) => {
  // Iterate through fields to check if the field exists
  let fieldExists = false;
  for (let a = 0; a < fields?.length; a++) {
    if (fields[a].name === "Sidebyside") {
      // Check within subfields for Sidebyside type
      for (let b = 0; b < fields[a].Subfields.length; b++) {
        if (fields[a].Subfields[b].name === name) {
          fieldExists = true;
          break;
        }
      }
    } else {
      // Direct check for other fields
      if (fields[a].name === name) {
        fieldExists = true;
        break;
      }
    }
  }
  return fieldExists;
};

const excludedKeys = ["OpenReviewModal","GetFileValues"];
// this are functions  for cred operations for forms
export const updateValueForm = (formRef, values) => {
  // console.log({ formRef, values }, "valuesvaluesvaluesvaluesvaluesvalues");
  if (formRef?.current && values) {
    Object.keys(formRef.current)?.forEach((key) => {
      if (excludedKeys?.includes(key)) {
        // Skip updating for excluded keys
        return;
      }
      formRef?.current?.[key]?.updateForm(values);
    });
  }
};

export const UpdateValuesWithoutField = (data, formRef, Type, UpdateType) => {
  formRef?.current?.[Type]?.updataWithoutFields(data, UpdateType);
};

export const updateSingleField = (formRef, name, value) => {
  // console.log({ formRef, name, value }, "valuesvaluesvaluesvaluesvaluesvalues");
  if (formRef?.current && name) {
    Object.keys(formRef.current)?.forEach((key) => {
      if (excludedKeys?.includes(key)) {
        // Skip updating for excluded keys
        return;
      }
      formRef?.current?.[key]?.updateSingleField(name, value);
    });
  }
};

export const ClearFields = (formRef, InpType = "InputDropForQuery") => {
  if (formRef?.current) {
    Object.keys(formRef?.current)?.forEach((key) => {
      if (excludedKeys?.includes(key)) {
        // Skip updating for excluded keys
        return;
      }
      console.log(formRef?.current);
      if (formRef?.current?.[key] && Object.keys(formRef?.current?.[key])?.length > 0) {
        formRef?.current?.[key]?.resetForm(InpType);
      }
    });
  }
};

export const handleFormSubmit = (formRef) => {
  if (formRef?.current) {
    Object.keys(formRef.current)?.forEach((key) => {
      if (excludedKeys.includes(key)) {
        // Skip updating for excluded keys
        return;
      }
      formRef?.current[key]?.submitForm();
    });
  }
};

export const handleFormReset = (formRef) => {
  if (formRef?.current) {
    console.log(formRef?.current);
    Object.keys(formRef.current)?.forEach((key) => {
      console.log(key);
      if (excludedKeys.includes(key)) {
        // Skip updating for excluded keys
        return;
      }
      formRef?.current[key]?.resetForm();
      console.log(formRef?.current[key], key);
    });
  }
};

export function calculateTotal(array, FormData) {
  let expression = "";
  let previousValid = false;

  array?.forEach((item, index) => {
    if (FormData[item.name] === undefined || FormData[item.name] === null || isNaN(FormData[item.name])) {
      // Skip this item if name is not a number
      return;
    }

    if (previousValid && index !== 0) {
      expression += ` ${item.opt} `;
    }

    expression += FormData[item.name];
    previousValid = true;
  });

  // Evaluate the expression safely
  try {
    return new Function(`return ${expression};`)();
  } catch (e) {
    console.error("Invalid expression:", expression);
    return null;
  }
}

export function getDaysDifference(date1, date2) {
  // Helper function to convert date string from DD/MM/YYYY to Date object
  function parseDate(dateStr) {
    const dateParts = dateStr.split("/").reverse();
    return new Date(dateParts.join("-"));
  }

  const firstDate = parseDate(date1);
  const secondDate = parseDate(date2);

  // Calculate the difference in time (milliseconds)
  const differenceInTime = secondDate - firstDate;

  // Convert the difference from milliseconds to days
  const differenceInDays = differenceInTime / (1000 * 60 * 60 * 24);

  return Math.abs(differenceInDays + 1); // Return absolute difference to avoid negative values
}

export const CheckTypeofInput = (fields, type) => {
  // Create an array to store the fields of the specified type
  const filteredFields = [];

  // Iterate through fields
  for (let a = 0; a < fields?.length; a++) {
    if (fields[a].name === "Sidebyside" && fields[a].Subfields) {
      // Check within subfields for Sidebyside type
      for (let b = 0; b < fields[a].Subfields.length; b++) {
        if (fields[a].Subfields[b].type === type) {
          filteredFields.push(fields[a].Subfields[b]);
        }
      }
    } else {
      // Direct check for other fields
      if (fields[a].type === type) {
        filteredFields.push(fields[a]);
      }
    }
  }

  return filteredFields;
};

export const validationAdditional = (data) => {
  let newData = data?.map((e) => {
    let parseData;
    if (e.Additional_Info && e.Additional_Info.trim()) {
      parseData = parseTheAdditionInfo(e);
    }
    return {
      ...e,
      ...parseData,
    };
  });
  return newData;
};
